import "../Firebase";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  // setPersistence,
  // browserSessionPersistence
} from "firebase/auth";
import { getDatabase, ref, set, child, get } from "firebase/database";

const auth = getAuth();
const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: "select_account" });
provider.addScope("profile");
provider.addScope("email");

export const signInWithGoogle = () =>
  signInWithPopup(auth, provider)
    .then((result) => {
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential.accessToken;
      let user = result.user;
      let db = getDatabase();
      const dbRef = ref(getDatabase());
      get(child(dbRef, `users/${user.uid}`))
        .then((snapshot) => {
          if (snapshot.exists()) {
            user = snapshot.val();
            console.log(user);
          } else {
            set(ref(db, "users/" + user.uid), {
              username: user.displayName,
              email: user.email,
              profile_picture: user.photoURL,
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    })
    .catch((error) => {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
    });

export const isLogin = () => {
  return auth.currentUser ? true : false;
};

export const signOut = () => {
  auth.signOut();
};

export const getUid = () => {
  return auth.currentUser.uid;
};
